import { formatBRL, formatDateBR } from './formatters';

// Export contracts to CSV
export const exportContractsToCSV = (contracts, emailsByContract) => {
  const headers = [
    'Cliente',
    'Email',
    'Produto',
    'Valor Total',
    'Parcelas',
    'Valor Parcela',
    'Data Inicio',
    'Status',
    'Parcelas Pagas',
    'Parcelas Pendentes'
  ];

  const rows = contracts.map(contract => {
    const contractEmails = emailsByContract[contract.id] || [];
    const paidParcels = contractEmails.filter(e => e.status === 'paid').length;
    const pendingParcels = contract.numParcels - paidParcels;

    return [
      contract.clientName,
      contract.email,
      contract.product,
      formatBRL(contract.totalValue),
      contract.numParcels,
      formatBRL(contract.totalValue / contract.numParcels),
      contract.startDate?.toDate ? formatDateBR(contract.startDate.toDate()) : '',
      paidParcels === contract.numParcels ? 'Concluido' : paidParcels > 0 ? 'Ativo' : 'Pendente',
      paidParcels,
      pendingParcels
    ];
  });

  return generateCSV(headers, rows, 'contratos');
};

// Export revenue projection to CSV
export const exportRevenueToCSV = (revenueProjection) => {
  const headers = [
    'Mes',
    'Total Previsto',
    'Recebido',
    'Pendente',
    'Atrasado',
    'Numero de Parcelas'
  ];

  const rows = Object.entries(revenueProjection).map(([_, monthData]) => [
    monthData.monthName,
    formatBRL(monthData.total),
    formatBRL(monthData.paid),
    formatBRL(monthData.pending),
    formatBRL(monthData.overdue),
    monthData.contracts.length
  ]);

  return generateCSV(headers, rows, 'receitas');
};

// Export email logs to CSV
export const exportEmailLogsToCSV = (emails, contracts) => {
  const headers = [
    'Data Agendada',
    'Cliente',
    'Email Destinatario',
    'Tipo',
    'Assunto',
    'Status',
    'Parcela',
    'Valor'
  ];

  const getContractById = (id) => contracts.find(c => c.id === id);

  const rows = emails.map(email => {
    const contract = getContractById(email.contractId);
    return [
      email.scheduledDate?.toLocaleDateString('pt-BR') || '',
      email.clientName || contract?.clientName || '',
      email.email || contract?.email || '',
      getEmailTypeLabel(email.type),
      email.subject || '',
      email.status === 'sent' ? 'Enviado' : 'Agendado',
      email.parcelNum || '-',
      email.value ? formatBRL(email.value) : '-'
    ];
  });

  return generateCSV(headers, rows, 'emails');
};

// Helper to get email type label in Portuguese
const getEmailTypeLabel = (type) => {
  const labels = {
    welcome: 'Boas-vindas',
    reminder: 'Lembrete',
    payment: 'Cobranca',
    followup: 'Follow-up'
  };
  return labels[type] || type;
};

// Generate CSV file and trigger download
const generateCSV = (headers, rows, filename) => {
  // Escape special characters in CSV
  const escapeCSV = (value) => {
    if (value === null || value === undefined) return '';
    const str = String(value);
    if (str.includes(',') || str.includes('"') || str.includes('\n')) {
      return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
  };

  const csvContent = [
    headers.map(escapeCSV).join(','),
    ...rows.map(row => row.map(escapeCSV).join(','))
  ].join('\n');

  // Add BOM for Excel UTF-8 compatibility
  const BOM = '\uFEFF';
  const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });

  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);

  const date = new Date().toISOString().split('T')[0];
  link.setAttribute('href', url);
  link.setAttribute('download', `${filename}_${date}.csv`);
  link.style.visibility = 'hidden';

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  return true;
};

export default {
  exportContractsToCSV,
  exportRevenueToCSV,
  exportEmailLogsToCSV
};
